import { ReactNode } from 'react';
import { Button } from '../components';
import { cn } from '../utils';

export interface LoginPageLayoutProps {
  isLoading: boolean;
  login: () => void;
  title: string;
  description: string;
  buttonLoadingText: string;
  buttonBaseText: string;
  backgroundImageSrc: string;
  logoIconSrc: string;
  infoMessage?: string;
  hero?: ReactNode;
  termsInfo?: ReactNode;
}

export const LoginPageLayout = ({
  isLoading,
  login,
  title,
  description,
  buttonLoadingText,
  buttonBaseText,
  backgroundImageSrc,
  logoIconSrc,
  infoMessage,
  termsInfo,
  hero,
}: LoginPageLayoutProps) => (
  <div
    className="relative flex min-h-screen flex-row items-center justify-center bg-cover bg-center"
    style={{ backgroundImage: `url(${backgroundImageSrc})` }}
  >
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-8 px-2 lg:px-16 xl:px-32',
        hero && 'lg:flex-row lg:gap-16'
      )}
    >
      {hero}
      <div
        className="animate-dissolve relative flex w-[90%] max-w-[548px] flex-col items-center justify-center gap-4 rounded-[32px] px-6 py-10"
        style={{
          background:
            'linear-gradient(279.59deg, rgba(182, 234, 236, 0.299) 10.94%, rgba(254, 247, 234, 0.46) 93.89%)',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
        }}
      >
        {/* TODO: add component for container with gradient border */}
        <div
          className="pointer-events-none absolute inset-0 rounded-[32px]"
          style={{
            padding: '1px',
            background:
              'linear-gradient(270deg, #2FCFD3 0%, #B6EAEC 30%, #E5E7EB 60%, #FEF7EA 100%)',
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            maskComposite: 'exclude',
            WebkitMask:
              'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
          }}
        />
        <img
          src={logoIconSrc}
          alt="SpendBrain logo"
          className="size-[200px] object-contain md:size-[240px]"
        />
        <div className="flex flex-col items-center justify-center gap-6 px-10 md:gap-10">
          <h1 className="text-primary text-center">{title}</h1>
          <p className="text-muted-foreground text-center">{description}</p>
        </div>
        <Button className="h-10 px-12.5" disabled={isLoading} onClick={login}>
          {isLoading ? buttonLoadingText : buttonBaseText}
        </Button>
        {isLoading && infoMessage && (
          <p className="text-muted-foreground text-center">{infoMessage}</p>
        )}
        {termsInfo && (
          <p className="text-center text-xs text-[#65758B]">{termsInfo}</p>
        )}
      </div>
    </div>
  </div>
);
